module.exports = __webpack_public_path__ + "img/games-11.0937cdb8.jpg";